import axios from 'axios'
import storage from '@/utils/storage'

export default () => {
  const bbaxios = axios.create({
    baseURL:
      storage.getItem('apiBaseV2') || 'https://api.bytbostad.se/api/v2',
    withCredentials: true,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })

  bbaxios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    return Promise.reject(error)
  })

  return bbaxios
}
